import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-bump",
  "use": "icon-icon-bump-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-bump\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 4H17V6H3V4ZM3 9H13V11H3V9ZM17 9H15V11H17V9ZM3 14H9V16H3V14ZM13 14H11V16H13V14Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol